import { PostloadedImage } from '@utils/react';
import { image } from './input.image.style.js';
import { jsx } from 'react/jsx-runtime';

function InTableImageInput(props) {
  return /*#__PURE__*/jsx(PostloadedImage, {
    className: image,
    src: props.input.src,
    alt: props.input.alt ?? ""
  });
}

export { InTableImageInput };
//# sourceMappingURL=input.image.js.map
